import { ResellerPlanDetails } from './types';
import { v4 as uuidv4 } from 'uuid';

const createNewPlan = (): ResellerPlanDetails => {
  const planNumber = Math.floor(10000 + Math.random() * 90000).toString();
  
  return {
    id: uuidv4(),
    name: 'New Reseller Plan',
    description: 'Custom reseller plan with white-label options',
    planType: 'reseller',
    setupFee: 99,
    annualPrice: 999,
    maxInstances: 3,
    maxManagers: 3,
    maxAdmins: 50,
    maxUsers: 1000,
    recommended: false,
    planNumber,
    features: [
      { name: 'White-labeled instances', included: true },
      { name: 'Custom domain support', included: true },
      { name: 'Email support', included: true }
    ]
  };
};

export const createPlanOperations = (
  resellerPlans: ResellerPlanDetails[],
  setResellerPlans: React.Dispatch<React.SetStateAction<ResellerPlanDetails[]>>
) => {
  const updateResellerPlan = (index: number, field: keyof ResellerPlanDetails, value: any) => {
    const updatedPlans = [...resellerPlans];
    updatedPlans[index] = {
      ...updatedPlans[index],
      [field]: value
    };
    setResellerPlans(updatedPlans);
  };

  const addResellerPlan = () => {
    const newPlan = createNewPlan();
    setResellerPlans([...resellerPlans, newPlan]);
  };

  const deleteResellerPlan = (index: number) => {
    const updatedPlans = [...resellerPlans];
    updatedPlans.splice(index, 1);
    setResellerPlans(updatedPlans);
  };

  return {
    updateResellerPlan,
    addResellerPlan,
    deleteResellerPlan,
  };
};

export { createNewPlan };
